import React, { useState } from 'react';
import { PageLayout } from '@/shared/layout';
import { Button, Card, Search, FeaturePlaceholder } from '@/components/ui';
import { useAuth } from '@/core/auth/AuthContext';
import { useAssetGroups } from './hooks/useAssets';

export default function AssetGroupsPage() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  const [search, setSearch] = useState('');

  // Note: Asset groups are project-specific in the requirement,
  // but for the list view we might want to show all or filter by project.
  const { data: groups = [], isLoading } = useAssetGroups();

  return (
    <PageLayout
      title="Nhóm Tài sản"
      description="Quản lý các nhóm phân loại tài sản để tối ưu hóa việc gán workload và kế hoạch bảo dưỡng."
      breadcrumbs={[{ label: 'Tài sản', path: '/maintenance/assets' }, { label: 'Nhóm tài sản' }]}
      isLoading={isLoading}
      headerActions={
        <Button variant="primary" icon="ri-add-line">Tạo nhóm mới</Button>
      }
    >
      <div className="space-y-6">
        <PageLayout.Toolbar>
          <div className="flex gap-4">
            <Search
              placeholder="Tìm tên nhóm..."
              value={search}
              onChange={setSearch}
              className="w-80"
            />
          </div>
        </PageLayout.Toolbar>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {groups.length > 0 ? groups.map(group => (
            <Card key={group.id} className="p-6 hover:shadow-md transition-shadow cursor-pointer border-none shadow-sm">
              <div className="flex justify-between items-start mb-4">
                <div className="w-12 h-12 bg-os-primary/10 rounded-xl flex items-center justify-center text-os-primary">
                  <i className="ri-folder-zip-line text-2xl" />
                </div>
                <Button variant="ghost" size="sm" icon="ri-more-2-fill" />
              </div>
              <h3 className="font-bold text-slate-900 mb-1">{group.group_name}</h3>
              <p className="text-xs text-slate-500 line-clamp-2 mb-4">{group.description || 'Không có mô tả'}</p>
              <div className="flex justify-between items-center pt-4 border-t border-slate-50">
                <span className="text-[10px] text-slate-400 font-bold ">12 Tài sản</span>
                <span className="text-[10px] text-slate-400 font-bold ">2 Workloads</span>
              </div>
            </Card>
          )) : (
            <div className="col-span-full">
              <FeaturePlaceholder
                title="Quản lý Nhóm Tài sản"
                description="Tính năng nhóm tài sản giúp bạn quản lý hàng nghìn đối tượng theo các tiêu chuẩn bảo dưỡng chung."
              />
            </div>
          )}
        </div>
      </div>
    </PageLayout>
  );
}
